import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { PRODUCTION_STOP_REASON, } from '../types/production-stop-reason.js';
import { SECTOR } from '../types/sector.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for ProductionStopReason (stop-reason catalog).
 * Stored in 'org/{orgId}/production-stop-reason'.
 */
export const productionStopReasonDescriptor = {
    name: PRODUCTION_STOP_REASON,
    label: 'Motivo de parada',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/production-stop-reason',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Catalog of production stop reasons (planned vs unplanned)',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique stop-reason identifier',
        },
        {
            name: 'code',
            label: 'Código',
            type: 'number',
            required: true,
            unique: true,
            autoNumber: true,
            description: 'Numeric catalog code (master-data identifier; non-negative, capped at MAX_CODE_SMALL)',
        },
        {
            name: 'description',
            label: 'Descrição',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Stop-reason description',
        },
        {
            name: 'planned',
            label: 'Programada',
            type: 'boolean',
            required: true,
            description: 'true = planned stop; false = unplanned (default)',
        },
        {
            name: 'sectorId',
            label: 'Setor',
            type: 'string',
            required: false,
            description: 'Optional sector this reason typically applies to (informative only)',
        },
        {
            name: 'notes',
            label: 'Observações',
            type: 'string',
            required: false,
            maxLength: FIELD_LIMITS.NOTES,
            description: 'Free-text notes',
        },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [
        ...AUDIT_FOREIGN_KEYS,
        {
            fieldName: 'sectorId',
            targetEntity: SECTOR,
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Optional sector this reason typically applies to',
        },
    ],
};
//# sourceMappingURL=production-stop-reason.descriptor.js.map